'use client';

import React from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Image from 'next/image';
import { DEFAULT_IMAGE_PATH } from '@web/constants/general';

type IImageViewerProps = {
  urls: string[];
  height?: string | number | undefined;
  width?: string | number | undefined;
  className?: string;
};

export const ImageViewer = ({
  urls,
  height = 340,
  width = 560,
  className = undefined,
}: IImageViewerProps) => {
  return (
    <PhotoProvider>
      <div className={className ? className : 'flex gap-4 overflow-auto '}>
        {urls.map((url) => (
          <div
            key={url}
            style={{
              minWidth: width,
              height: height,
            }}
            className="hover:opacity-hover relative w-full cursor-zoom-in overflow-clip rounded-2xl"
          >
            {url ? (
              <PhotoView src={url}>
                <Image
                  priority
                  src={url}
                  alt={url}
                  fill
                  sizes="(min-width: 384px)"
                  style={{
                    objectFit: 'cover',
                  }}
                />
              </PhotoView>
            ) : (
              <Image
                src={DEFAULT_IMAGE_PATH}
                alt={url}
                fill
                sizes="(min-width: 384px)"
                style={{
                  objectFit: 'cover',
                }}
              />
            )}
          </div>
        ))}
      </div>
    </PhotoProvider>
  );
};
